export default __webpack_public_path__ + "assets/a31585eaf5dd6ba235da0e14880c4d0f.jpg";